import { render, staticRenderFns } from "./SectionAccounts.vue?vue&type=template&id=00908f97&scoped=true&"
import script from "./SectionAccounts.vue?vue&type=script&lang=js&"
export * from "./SectionAccounts.vue?vue&type=script&lang=js&"
import style0 from "./SectionAccounts.vue?vue&type=style&index=0&id=00908f97&prod&lang=sass&scoped=true&"
import style1 from "./SectionAccounts.vue?vue&type=style&index=1&id=00908f97&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00908f97",
  null
  
)

export default component.exports